import { useLayoutEffect } from 'react'
import { useSubscriptionPlansQuery } from '@mwxltd/flix-api-client'
import { PlanPromoBlockV1, PlansPromoList } from '@flix/common/domain/subscriptions'
import { Button } from '@flix/common/elements/controls'
import { ActivityIndicator } from '@flix/common/elements/status'
import { H1 } from '@flix/common/elements/typography'
import { LoadingSection } from '../../../../components/layout/Loading/LoadingSection'
import { ifSubscribedGoTo } from '../../../routeGuards/routeGuards'
import { Container } from '../../components/Wizard/Wizard'
import { SUBSCRIBE_WIZARD_PATH } from '../../constants'
import { useWizardState } from '../../useWizardState'

const Step1ChoosePlan = ({ history, location }) => {
  const { setChosenPlan, marketingSource } = useWizardState()
  const onChoosePlan = (plan) => {
    setChosenPlan(plan)
    history.push(`${SUBSCRIBE_WIZARD_PATH}/subscribe`)
  }

  const {
    data: { choosePlan, plans },
    loading,
  } = useSubscriptionPlansQuery(
    {
      provider: 'stripe' + (marketingSource ? `?marketingSource=${marketingSource}` : ''),
    },
    {
      fetchPolicy: 'cache-and-network',
    },
  )

  useLayoutEffect(() => {
    const query = new URLSearchParams(location.search)
    if (query.get('chosenPlan') && !loading && plans?.length) {
      const chosenPlan = plans.find((item) => item.type === query.get('chosenPlan'))
      query.delete('chosenPlan')
      onChoosePlan(chosenPlan)
    }
  }, [plans])

  if (loading && !plans?.length) {
    return (
      <LoadingSection>
        <ActivityIndicator />
      </LoadingSection>
    )
  }

  return (
    <Container>
      <H1 center marginBottom="xlarge">
        {choosePlan.title}
      </H1>

      <PlansPromoList>
        {plans.map((plan) => (
          <PlanPromoBlockV1 key={plan.type} plan={plan}>
            <Button
              minWidth={200}
              variant="primary"
              title={plan.promoBlock.v1.buttonText}
              onPress={() => onChoosePlan(plan)}
            />
          </PlanPromoBlockV1>
        ))}
      </PlansPromoList>
    </Container>
  )
}

export default ifSubscribedGoTo(`${SUBSCRIBE_WIZARD_PATH}/verify`)(Step1ChoosePlan)
